/**
 * StatusBadge — subtle colored pill for run statuses.
 */
const STYLES = {
  passed:  "bg-[#10B981]/10 text-[#047857] border-[#10B981]/20",
  failed:  "bg-[#EF4444]/10 text-[#B91C1C] border-[#EF4444]/20",
  running: "bg-[#3B82F6]/10 text-[#1D4ED8] border-[#3B82F6]/20 animate-pulse",
};

export const StatusBadge = ({ status, testId }) => {
  if (!status) {
    return (
      <span
        data-testid={testId}
        className="inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full border border-[#E5E7EB] text-[#64748B] bg-[#F8FAFC]"
      >
        Never run
      </span>
    );
  }
  const label = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full border ${STYLES[status] || STYLES.running}`}
    >
      {label}
    </span>
  );
};
